<template>
  <div>
    <h1>Pos {{ $t('occupancy') }} {{ $tc('status', 1) }}</h1>
    <button class="btn-modal-close" v-on:click="closeModalSection()">&times;</button>
  </div>
</template>

<script>
export default {
  props: {
    onClickCloseHandler: {
      type: Function
    }
  },
  methods: {
    closeModalSection: function() {
      this.onClickCloseHandler();
    }
  }
};
</script>
 


// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/posOccupancyStatus.vue